<template>
  <div class="com disFlex fc fbt">
    <div class="com-left disFlex vertical fbt">
      <div class="name">{{item.name}}</div>
      <div class="phone">{{item.phone}}</div>
      <div class="address disFlex fc">
        <img src="https://j.weizan.cn/youxiang/addr-icon.png" class="addr-icon" />
        <div class="addr">{{item.address}}</div>
      </div>
    </div>

    <div class="com-right" v-if="index===0">
      <img :src="logo" class="shop-img" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      default: {},
    },
    index: {
      type: Number,
      default: 0,
    },
    logo: {
      type: String,
      default: "",
    },
  },
};
</script>
<style lang="less" scoped>
.com {
  padding: 18px 15px;
  .com-left {
    height: 68px;
    .name {
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: bold;
      color: rgba(53, 53, 53, 1);
    }
    .phone {
      font-size: 12px;
      font-family: PingFang SC;
      font-weight: bold;
      color: rgba(0, 48, 120, 1);
    }
    .address {
      font-size: 12px;
      font-family: PingFang SC;
      font-weight: 500;
      color: rgba(116, 116, 116, 1);
      .addr-icon {
        margin-right: 5px;
        width: 10px;
        height: 12px;
      }
    }
  }
  .com-right {
    width: 90px;
    height: 51px;
    background: rgba(216, 216, 216, 1);
    border-radius: 1px;
    .shop-img {
      width: 90px;
      height: 51px;
    }
  }
}
</style>